import { createTheme } from '@mui/material/styles';
import {
  PRIMARY_MAIN,
  SECONDARY_MAIN,
  CHAT_LEFT_PANEL_BACKGROUND,
  HEADER_BACKGROUND,
  primary_50
} from './utilities/constants.jsx';  // Import constants

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    fontFamily: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
    h1: {
      fontSize: '3rem',
      lineHeight: '3.3rem',
      '@media (max-width:600px)': {
        fontSize: '2.25rem',
        lineHeight: '2.2rem',
      },
    },
    h2: {
      fontSize: '2rem',
      lineHeight: '2.2rem',
      '@media (max-width:600px)': {
        fontSize: '1.75rem',
        lineHeight: '2rem',
      },
    },
    h3: {
      fontSize: '1.5rem',
      lineHeight: '1.75rem',
      '@media (max-width:600px)': {
        fontSize: '1.5rem',
        lineHeight: '1.75rem',
      },
    },
    h4: {
      fontSize: '1.25rem',
      lineHeight: '1.625rem',
      '@media (max-width:600px)': {
        fontSize: '1.25rem',
        lineHeight: '1.625rem',
      },
    },
    h5: {
      fontSize: '1.125rem',
      '@media (max-width:600px)': {
        fontSize: '1rem',
      },
    },
    h6: {
      fontSize: '1rem',
      '@media (max-width:600px)': {
        fontSize: '0.875rem',
      },
    },
    body1: {
      fontSize: '1rem',
      lineHeight: '1.375rem',
      '@media (max-width:600px)': {
        fontSize: '1rem',
        lineHeight: '1.375rem',
      },
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: '1rem',
      '@media (max-width:600px)': {
        fontSize: '0.875rem',
        lineHeight: '1rem',
      },
    },
  },
  palette: {
    primary: {
      main: PRIMARY_MAIN,
      light: '#2878C8',
      dark: '#1F476F',
      50: primary_50,
    },
    secondary: {
      main: SECONDARY_MAIN,
    },
    error: {
      main: '#9C201C',
    },
    warning: {
      main: '#CD4C1E',
    },
    text: {
      primary: '#2B2B2B',
      secondary: '#6C757D',
    },
    background: {
      default: '#FFFFFF',
      paper: '#F7F6F6',
      chatLeftPanel: CHAT_LEFT_PANEL_BACKGROUND,
      header: HEADER_BACKGROUND,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,  // Rounded corners for buttons
          textTransform: 'none',  // Disable text transform on buttons
          minHeight: 44, // Minimum touch target size for mobile
          '&:focus-visible': {
            outline: '2px solid #2878C8',
            outlineOffset: '2px',
          },
          '@media (max-width:600px)': {
            minHeight: 48, // Larger touch targets on mobile
            fontSize: '0.875rem',
            padding: '12px 16px',
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          minHeight: 44, // Minimum touch target size for mobile
          minWidth: 44,
          '&:focus-visible': {
            outline: '2px solid #2878C8',
            outlineOffset: '2px',
          },
          '@media (max-width:600px)': {
            minHeight: 48,
            minWidth: 48,
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          '@media (max-width:900px)': {
            width: '100%',
            maxWidth: '320px',
          },
        },
      },
    },
  },
});

export default theme;
